import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-flat-document',
  templateUrl: './flat-document.component.html',
  styleUrls: ['./flat-document.component.scss']
})
export class FlatDocumentComponent implements OnInit {

  FilesNote_DS: any = {};
  emptyFilesNote_DS: any = {};

  sections = [];

  constructor(
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.getFilesNoteDS();
  }

  getFilesNoteDS() {
    this.generalService.getDS("FilesNote")
      .subscribe((ds: any) => {
        Object.assign(this.emptyFilesNote_DS, ds.FilesNote[0]);
        Object.assign(this.FilesNote_DS, ds);
      });
  }

  //#region Section
  addNewSection() {
    let newDS: any = {};
    Object.assign(newDS, this.emptyFilesNote_DS);
    this.FilesNote_DS.FilesNote.push(newDS);
  }

  deleteSection(index) {
    this.FilesNote_DS.FilesNote.splice(index, 1);
  }
  save() {
    this.transformDS();
    this.sections = [];
    this.sections.forEach(ds => {
      this.generalService.enregisterTable(ds)
        .subscribe((res) => { });
    });
  }

  transformDS() {
    let apiForm: any = {};
    Object.assign(apiForm, this.FilesNote_DS.ApiForm);
    this.FilesNote_DS.FilesNote.forEach(element => {
      this.sections.push({
        ApiForm: apiForm,
        FilesNote: [element]
      });
    });
  }
  //#endregion

}
